/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitGuidelineExtensionEnum } from './PressKitGuidelineExtensionEnum';
import {
    PressKitGuidelineExtensionEnumFromJSON,
    PressKitGuidelineExtensionEnumFromJSONTyped,
    PressKitGuidelineExtensionEnumToJSON,
} from './PressKitGuidelineExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';

/**
 * 
 * @export
 * @interface PostPressKitBodyGuidelineFilesInner
 */
export interface PostPressKitBodyGuidelineFilesInner {
    /**
     * エラー箇所を特定するために必要な各オブジェクトのID
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    objectId: string;
    /**
     * ファイルのUUID。空文字だと新規作成される。
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    id?: string;
    /**
     * S3へのURI、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    resourceUri: string;
    /**
     * 
     * @type {PressKitGuidelineExtensionEnum}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    extension: PressKitGuidelineExtensionEnum;
    /**
     * アップロードされたファイルの名前。resource_uri変更時だけ変更可能。
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    filename: string;
    /**
     * ファイルのサイズ（単位はbytes）。resource_uri変更時だけ変更可能。
     * @type {number}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    fileSize: number;
    /**
     * キャプションとして使われるファイルの名前。設定されなければfilenameが使われる。
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    title?: string;
    /**
     * 企業が登録したファイルの説明文
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    description?: string;
    /**
     * サムネイル画像が保存されたS3へのURI、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    thumbnailUri?: string;
    /**
     * 
     * @type {Array<PressKitTag>}
     * @memberof PostPressKitBodyGuidelineFilesInner
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PostPressKitBodyGuidelineFilesInner interface.
 */
export function instanceOfPostPressKitBodyGuidelineFilesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "objectId" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PostPressKitBodyGuidelineFilesInnerFromJSON(json: any): PostPressKitBodyGuidelineFilesInner {
    return PostPressKitBodyGuidelineFilesInnerFromJSONTyped(json, false);
}

export function PostPressKitBodyGuidelineFilesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressKitBodyGuidelineFilesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'objectId': json['__object_id'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'resourceUri': json['resource_uri'],
        'extension': PressKitGuidelineExtensionEnumFromJSON(json['extension']),
        'filename': json['filename'],
        'fileSize': json['file_size'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'thumbnailUri': !exists(json, 'thumbnail_uri') ? undefined : json['thumbnail_uri'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PostPressKitBodyGuidelineFilesInnerToJSON(value?: PostPressKitBodyGuidelineFilesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        '__object_id': value.objectId,
        'id': value.id,
        'resource_uri': value.resourceUri,
        'extension': PressKitGuidelineExtensionEnumToJSON(value.extension),
        'filename': value.filename,
        'file_size': value.fileSize,
        'title': value.title,
        'description': value.description,
        'thumbnail_uri': value.thumbnailUri,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

